module.exports = __webpack_public_path__ + "img/personQuestionMark.1528b771.svg";